import React, { useState } from 'react';

interface JobInquiryFormProps {
  jobListingId: number;
}

/**
 * Job inquiry form component that displays consultation options for guest users
 * @param jobListingId - The ID of the job listing to associate with the inquiry
 */
const JobInquiryForm: React.FC<JobInquiryFormProps> = ({ jobListingId }) => {
  const [selectedOptions, setSelectedOptions] = useState<number[]>([]);

  const inquiryOptions = [
    { id: 1, text: 'フリーランス案件と正社員求人の違いを知りたい' },
    { id: 2, text: '自分の経験に基づいた単価相場を知りたい' },
    { id: 3, text: 'リモートワークで参加可能な案件を探したい' },
    { id: 4, text: '自分のスキルに合った案件を探したい' },
    { id: 5, text: 'プロジェクトでの裁量権の範囲を知りたい' }
  ];

  /**
   * Toggle checkbox selection
   * @param optionId - The ID of the option to toggle
   */
  const toggleOption = (optionId: number) => {
    setSelectedOptions(prev => {
      const newOptions = prev.includes(optionId) 
        ? prev.filter(id => id !== optionId)
        : [...prev, optionId];
      return newOptions;
    });
  };

  /**
   * Handle CTA button click - redirect to apply signup with job parameters
   */
  const handleInquiryClick = () => {
    const params = new URLSearchParams({
      job_listing_id: jobListingId.toString()
    });
    
    window.location.href = `/apply/sign_up?${params.toString()}`;
  };

  return (
    <div className="mb-4 mt-5">
      <div className="card" style={{ 
        backgroundColor: '#f8f9ff', 
        border: '1px solid #e3e8ff',
        borderRadius: '12px'
      }}>
        <div className="card-body p-4">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-start mb-3">
            <h5 className="card-title mb-0 fw-bold text-dark" style={{ fontSize: '1.1rem' }}>
              案件について詳しく聞いてみませんか？
            </h5>
            {/* Illustration placeholder */}
            <div className="d-flex align-items-center" style={{ fontSize: '1.5rem' }}>
              <i className="fas fa-comments text-primary"></i>
            </div>
          </div>

          {/* Divider */}
          <hr className="my-3" style={{ borderColor: '#e3e8ff' }} />

          {/* Instructions */}
          <p className="text-muted small mb-3">
            知りたい内容を選んでください（複数選択可）
          </p>

          {/* Checkbox Options */}
          <div className="mb-4">
            {inquiryOptions.map((option) => (
              <div 
                key={option.id}
                className="form-check mb-3"
                style={{ cursor: 'pointer' }}
              >
                <input
                  id={`inquiry-option-${option.id}`}
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedOptions.includes(option.id)}
                  onChange={() => toggleOption(option.id)}
                  style={{ 
                    transform: 'scale(1.2)',
                    marginTop: '0.1rem',
                    cursor: 'pointer'
                  }}
                />
                <label 
                  className="form-check-label ms-3"
                  htmlFor={`inquiry-option-${option.id}`}
                  style={{ 
                    cursor: 'pointer',
                    fontSize: '0.95rem',
                    lineHeight: '1.5',
                    fontWeight: '500'
                  }}
                >
                  {option.text}
                </label>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <button
              className="btn btn-primary px-4 py-2 fw-semibold"
              onClick={handleInquiryClick}
              style={{
                backgroundColor: '#0d6efd',
                borderColor: '#0d6efd',
                borderRadius: '8px',
                fontSize: '0.95rem',
                minWidth: '200px'
              }}
            >
              詳しく聞いてみる
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobInquiryForm;
